var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_977_13890",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33325 2.91667C2.17854 2.91667 2.03017 2.97812 1.92077 3.08752C1.81138 3.19692 1.74992 3.34529 1.74992 3.5V11.6667C1.74992 11.8214 1.81138 11.9697 1.92077 12.0791C2.03017 12.1885 2.17854 12.25 2.33325 12.25H10.4999C10.6546 12.25 10.803 12.1885 10.9124 12.0791C11.0218 11.9697 11.0833 11.8214 11.0833 11.6667V8.55167C11.0833 8.2295 11.3444 7.96833 11.6666 7.96833C11.9888 7.96833 12.2499 8.2295 12.2499 8.55167V11.6667C12.2499 12.1308 12.0655 12.5759 11.7374 12.9041C11.4092 13.2323 10.964 13.4167 10.4999 13.4167H2.33325C1.86912 13.4167 1.424 13.2323 1.09582 12.9041C0.767626 12.5759 0.583252 12.1308 0.583252 11.6667V3.5C0.583252 3.03587 0.767626 2.59075 1.09582 2.26256C1.424 1.93437 1.86912 1.75 2.33325 1.75H5.44825C5.77042 1.75 6.03159 2.01117 6.03159 2.33333C6.03159 2.6555 5.77042 2.91667 5.44825 2.91667H2.33325Z",
    fill: "#2F2F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0874 0.753862C10.3152 0.526056 10.6846 0.526056 10.9124 0.753862L13.2457 3.0872C13.4735 3.315 13.4735 3.68435 13.2457 3.91215L7.4124 9.74549C7.303 9.85488 7.15463 9.91634 6.99992 9.91634H4.66659C4.34442 9.91634 4.08325 9.65517 4.08325 9.33301V6.99967C4.08325 6.84497 4.14471 6.69659 4.25411 6.5872L10.0874 0.753862ZM5.24992 7.2413V8.74968H6.75829L12.0083 3.49967L10.4999 1.9913L5.24992 7.2413Z",
    fill: "#2F2F2F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_977_13890)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#BDC6D7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.908ca9cddb6f2afd312bfc80afb5885e.svg";
export { ForwardRef as ReactComponent };